import {JobOpeningBase} from 'model/jobOpeningBase';

export const JobOpeningSearchResult = JobOpeningBase.extend({
    'defaults': {
        'relatedExperts': null,
        'showRelated': -1,
    },
});
